export default __webpack_public_path__ + "static/media/BrandFont-black.72121e2c.svg";